import { render, staticRenderFns } from "./Disease.html?vue&type=template&id=b0f68a9a&"
import script from "./Disease.js?vue&type=script&lang=js&"
export * from "./Disease.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports